import { ToastHeader as _ToastHeader, ToastHeaderProps as _ToastHeaderProps } from "reactstrap";

    export const ToastHeader = _ToastHeader;
    export type ToastHeaderProps = _ToastHeaderProps;
    